import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() sectionTag = '';
  @Input() collapsible = false;
  @Input() initiallyCollapsed = false;

  isCollapsed = false;

  ngOnInit(): void {
    this.isCollapsed = this.initiallyCollapsed;
  }

  get collapseButtonLabel(): string {
    return this.isCollapsed ? 'Expandir painel' : 'Colapsar painel';
  }

  toggleCollapse(): void {
    if (!this.collapsible) {
      return;
    }

    this.isCollapsed = !this.isCollapsed;
  }
}
